import { render, staticRenderFns } from "./RoleChangePermissions.vue?vue&type=template&id=61faac9e&scoped=true"
import script from "./RoleChangePermissions.vue?vue&type=script&lang=ts"
export * from "./RoleChangePermissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61faac9e",
  null
  
)

export default component.exports